// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1PMOX","head":"Table_head__2T4qc","col":"Table_col__1YOU3"};